import { render } from "./MainChat.vue?vue&type=template&id=14c39a71"
import script from "./MainChat.vue?vue&type=script&lang=js"
export * from "./MainChat.vue?vue&type=script&lang=js"

import "./MainChat.vue?vue&type=style&index=0&id=14c39a71&lang=css"
script.render = render

export default script